import React from 'react';
import { Spinner, InfoMessage } from 'components';
import {
  DigitalTwin,
  useGetDigitalTwinQuery,
} from 'types/dt-graphql-apollo-v2';
import { Route, Switch } from 'react-router-dom';
import { ROUTE_DIGITAL_TWIN } from 'utils/router-url';
import styled from 'styled-components/macro';
import { useUrl } from 'hooks/useUrls';
import { IconType } from '@cognite/cogs.js';
import { DigitalTwinView } from './DigitalTwinView';

export type ITab = {
  slug: string;
  title: string;
  icon?: IconType;
  sublevels?: Array<{
    slug: string;
    title: string;
  }>;
};

export const ViewDigitalTwinPage = () => {
  const digitalTwinId = useUrl.DigitalTwinId();
  const { data, loading } = useGetDigitalTwinQuery({
    variables: {
      id: digitalTwinId,
    },
  });

  const digitalTwin = (data?.listDigitalTwin?.items &&
    data.listDigitalTwin.items[0]) as DigitalTwin;

  if (loading) {
    return <Spinner />;
  }

  if (!digitalTwin) {
    return (
      <InfoMessage type="Error" title="Unable to load this Digital Twin">
        Are you sure the Digital Twin exists?
      </InfoMessage>
    );
  }

  const renderDigitalTwinView = () => (
    <StyledContainer>
      <StyledContentPanel>
        <DigitalTwinView digitalTwin={digitalTwin} />
      </StyledContentPanel>
    </StyledContainer>
  );

  return (
    <Switch>
      <Route path={ROUTE_DIGITAL_TWIN}>{renderDigitalTwinView()}</Route>
    </Switch>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  background: var(--cogs-greyscale-grey1);
`;

const StyledContentPanel = styled.div`
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;
